import { useAuth } from '@/backend/context';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { SlugService } from '../services/slug-service';
import { QUERY_KEYS } from './query-keys';

export const useSlug = {
  /**
   * Obtiene los datos de branding para la página pública del cliente
   */

  /**
   * VERIFICACIÓN EN TIEMPO REAL
   * Se usa mientras el usuario escribe su "Enlace"
   */
  checkAvailability: (slug: string) => {
    // Obtenemos el ID del usuario actual
    const userId = useAuth((s) => s.user?.uid);

    const cleanSlug = slug.toLowerCase().trim();

    return useQuery({
      // Añadimos el userId a la queryKey para que se recalcule si cambia de cuenta
      queryKey: ['slug', 'availability', cleanSlug, userId],
      // Pasamos el userId al servicio
      queryFn: () => SlugService.isAvailable(cleanSlug, userId),
      enabled: cleanSlug.length >= 3 && !!slug && !!userId, // Solo ejecutar si hay usuario
      retry: false,
      staleTime: 0, // Siempre queremos la verdad actual
    });
  },

  /**
   * CREACIÓN / REGISTRO DEL ENLACE
   * Vincula el slug al perfil del dueño
   */
  create: () => {
    const queryClient = useQueryClient();
    const profile = useAuth((s) => s.profile);
    return useMutation({
      mutationFn: async (newSlug: string) => {
        // 1. Ajustamos la validación a la estructura plana que vemos en consola
        if (!profile || !profile.account_type) {
          throw new Error('No se encontró el tipo de cuenta en tu perfil.');
        }

        // 2. Creamos un objeto compatible con lo que espera tu SlugService
        // Si tu servicio espera profile.meta.accountType, lo construimos aquí
        const profileForService = {
          ...profile,
          meta: {
            accountType: profile.account_type, // Mapeamos account_type -> accountType
            ownerId: profile.public.meta.ownerId || profile.public.meta.ownerId,
            activeSubscription: profile.subscription === 'pro', // O la lógica que uses
          },
        };

        // 3. Ejecutamos la creación del enlace con el objeto adaptado
        return await SlugService.create(newSlug, profileForService as any);
      },
      onSuccess: (_, newSlug) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.SLUG_KEY, newSlug],
        });
        toast.success('¡Enlace personalizado activado!');
      },
      onError: (error: any) => {
        console.error('Error en la creación del slug:', error);
        toast.error(error.message || 'Error al registrar el enlace');
      },
    });
  },
};
